module.exports = __webpack_public_path__ + "static/media/podchaser-startup-logo.40584c18.png";